/* Korean (Korea) locale settings for Webix */
webix.i18n.locales['ko-KR'] = {
    groupDelimiter: ',', // Delimiter for groups of thousands
    groupSize: 3, // Size of groups of thousands
    decimalDelimiter: '.', // Delimiter for decimal part
    decimalSize: 2, // Number of decimal places
    dateFormat: '%Y-%n-%d', // Date format
    timeFormat: '%a %g:%i', // Time format
    longDateFormat: "%Y'년' %m'월' %j'일' %l", // Long date format
    fullDateFormat: "%Y'년' %m'월' %j'일' %l %a %g:%i", // Full date and time format
    am: ['오전', '오전'], // AM markers
    pm: ['오후', '오후'], // PM markers
    price: '₩{obj}', // Price format
    priceSettings: {
        groupDelimiter: ',', // Delimiter for groups of thousands in prices
        groupSize: 3, // Size of groups of thousands in prices
        decimalDelimiter: '.', // Delimiter for decimal part in prices
        decimalSize: 0, // Number of decimal places in prices
    },
    calendar: {
        monthFull: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'], // Full names of months
        monthShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'], // Short names of months
        dayFull: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'], // Full names of days
        dayShort: ['일', '월', '화', '수', '목', '금', '토'], // Short names of days
    },
};

// FILE DOCUMENTED
